export default {
    OBITO: 1,
    MUDANCA_DE_TERRITORIO : 2,
}